import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";
import { GetCollectionQuery } from "../../common/gql/graphql";
import { FacetValueIdPair, FacetWithValues } from "../../providers/facet-filter.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

type FilterPreset = NonNullable<
    NonNullable<NonNullable<GetCollectionQuery['collection']>['customFields']>['filterPresets']
>[number];

@Component({
    selector: 'kb-filter-preset-link',
    templateUrl: './filter-preset-link.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgClass,
        RouterLink,
        FontAwesomeModule,
    ],
})
export class FilterPresetLinkComponent implements OnChanges {
    @Input() preset: FilterPreset;
    @Input() activeFacetValues: FacetValueIdPair[];
    @Input() availableFacetValues: FacetWithValues[];
    facetValueIdPairs: FacetValueIdPair[];
    isActive = false;
    isDisabled = false;
    check = faCheck;

    ngOnChanges() {
        const availableFacetValues = this.getAvailableFacetValues();
        this.facetValueIdPairs = availableFacetValues.map((fv) => `${fv.facet.id}-${fv.id}` as const);
        this.isActive =
            0 < this.facetValueIdPairs.length &&
            this.facetValueIdPairs.every((pair) => this.activeFacetValues.includes(pair));
        this.isDisabled = availableFacetValues.length === 0;
    }

    toggleFacetValueIds(): string[] {
        if (this.facetValueIdPairs.every((pair) => this.activeFacetValues.includes(pair))) {
            return this.activeFacetValues.filter((pair) => !this.facetValueIdPairs.includes(pair));
        }
        return [...new Set([...this.activeFacetValues, ...this.facetValueIdPairs])];
    }

    private getAvailableFacetValues(): FilterPreset['facetValues'] {
        const output: FilterPreset['facetValues'] = [];
        for (const facetValue of this.preset?.facetValues ?? []) {
            const availableFacet = this.availableFacetValues.find((f) => f.id === facetValue.facet.id);
            if (availableFacet) {
                const availableFacetValue = availableFacet.values.find((v) => v.id === facetValue.id);
                if (availableFacetValue && availableFacetValue.count > 0) {
                    output.push(facetValue);
                }
            }
        }
        return output;
    }
}
